const $body = $(document.body),
      $toggleSwitch = $('.js-pricing-switch'),
      $monthlyPrice = $('.js-price-monthly'),
      $annualPrice = $('.js-price-annually'),
      $selectMonthly = $('.js-select-monthly'),
      $selectAnnually = $('.js-select-annually'),
      $priceNumMonthly = $('.js-price-num-monthly'),
      $priceNumAnnually = $('.js-price-num-annually'),
      $pricePer = $('.pricing-cards__per');

// 初期値: 10ユーザー（value="6,600"）
const initialIndex = $selectMonthly.find('option[value="6,600"]').index();

// Japanese pricing page
if ( $body.hasClass("page--pricing") ) {

  // 初期表示
  $selectMonthly.prop('selectedIndex', initialIndex);
  $selectAnnually.prop('selectedIndex', initialIndex);
  $priceNumMonthly.text($selectMonthly.val());
  $priceNumAnnually.text($selectAnnually.val());


  $toggleSwitch.on("click", function() {
    // Initialize switch
    $toggleSwitch.prop('disabled', false);

    // Change switch state
    $(this).prop('disabled', true);
    $toggleSwitch.toggleClass('-active');

    // Change selectbox
    $selectMonthly.toggleClass('is-hidden');
    $selectAnnually.toggleClass('is-hidden');

    // Change price area
    $monthlyPrice.toggleClass('is-hidden');
    $annualPrice.toggleClass('is-hidden');

    // 年契約がアクティブになったかどうかで価格変更
    const isAnnually = $toggleSwitch.eq(1).hasClass('-active');
    $pricePer.text(isAnnually ? '1人あたり ￥550' : '1人あたり ￥660');
  });

  let currentSelectorIndex = 0;
  // 状態を変数に入れてシンプルにすると可読性低下しそうなのであえて.changeは別々で書く
  $selectMonthly.on("change", function() {
    $('.js-price-num-monthly').text($(this).val());
    currentSelectorIndex = $selectMonthly.prop("selectedIndex");
    $selectAnnually.prop('selectedIndex', currentSelectorIndex);
    $('.js-price-num-annually').text($selectAnnually.val());
  });

  $selectAnnually.on("change", function() {
    $('.js-price-num-annually').text($(this).val());
    currentSelectorIndex = $selectAnnually.prop("selectedIndex");
    $selectMonthly.prop('selectedIndex', currentSelectorIndex);
    $('.js-price-num-monthly').text($selectMonthly.val());
  });

}
